import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminCancelledOrders from "../../components/dashboard/AdminCancelledOrders";

export default function AdminCancelledOrdersPage() {
  return (
    <DashboardLayout>
      <AdminCancelledOrders />
    </DashboardLayout>
  );
}
